import { Routes } from '@angular/router';

export const routes: Routes = [
    {
        path: '',
        redirectTo: 'fill',
        pathMatch: 'full'
    },
    {
        path: 'fill',
        loadChildren: () => import('./features/formularios/formularios.routes').then(m => m.FORMULARIOS_ROUTES)
    }
];
